module.exports = __webpack_public_path__ + "img/Create-Customer.b17ca9a0.gif";